'use strict';

exports.__esModule = true;
var USER = exports.USER = {
  GET_USER: 'USER_SET',
  SET_USER_DONE: 'USER_SET_DONE',
  SET_USER_FAIL: 'USER_SET_FAIL',
  SET_USER_LANGUAGE: 'SET_USER_LANGUAGE',
  SET_USER_LANGUAGE_DONE: 'SET_USER_LANGUAGE_DONE',
  SET_USER_LANGUAGE_FAIL: 'SET_USER_LANGUAGE_FAIL',
  USER_LANGUAGE_MODAL_TOGGLE: 'SET_USER_LANGUAGE_MODAL_TOGGLE'
};

var getUser = exports.getUser = function getUser(language) {
  return {
    type: USER.GET_USER,
    language: language
  };
};

var setUserDone = exports.setUserDone = function setUserDone(user) {
  return {
    type: USER.SET_USER_DONE,
    user: user
  };
};

var setUserFail = exports.setUserFail = function setUserFail(err) {
  return {
    type: USER.SET_USER_FAIL,
    err: err
  };
};

var toggleUserDefaultLangaugeModal = exports.toggleUserDefaultLangaugeModal = function toggleUserDefaultLangaugeModal(show) {
  return {
    type: USER.USER_LANGUAGE_MODAL_TOGGLE,
    show: show
  };
};

var setUserDefaultLangauge = exports.setUserDefaultLangauge = function setUserDefaultLangauge(languageId, reload) {
  return {
    type: USER.SET_USER_LANGUAGE,
    languageId: languageId,
    reload: reload
  };
};

var setUserDefaultLangaugeDone = exports.setUserDefaultLangaugeDone = function setUserDefaultLangaugeDone(language) {
  return {
    type: USER.SET_USER_LANGUAGE_DONE,
    language: language
  };
};

var setUserDefaultLangaugeFail = exports.setUserDefaultLangaugeFail = function setUserDefaultLangaugeFail() {
  return {
    type: USER.SET_USER_LANGUAGE_FAIL
  };
};